// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9MKLQ","grid-container":"xYlq0","col":"_2-cW8","story-wrapper":"_2U2Q8"};